import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlight = ({ features }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/20 rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
          <Icon name="Sparkles" size={20} color="var(--color-primary)" strokeWidth={2.5} />
        </div>
        <h3 className="text-lg font-semibold text-foreground">What's Coming</h3>
      </div>
      <ul className="space-y-3">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Icon name="CheckCircle2" size={18} color="var(--color-primary)" className="shrink-0 mt-0.5" />
            <span className="text-sm text-foreground">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FeatureHighlight;